/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _GroupToolbar = _interopRequireDefault(require("./GroupToolbar"));
var _default = function _default(_ref) {
  var groupBy = _ref.groupBy,
    columnsMap = _ref.columnsMap,
    onItemMouseDown = _ref.onItemMouseDown,
    onGroupByChange = _ref.onGroupByChange,
    ref = _ref.ref,
    theme = _ref.theme,
    onSortClick = _ref.onSortClick,
    headerGroupPlaceholderText = _ref.headerGroupPlaceholderText,
    renderSortTool = _ref.renderSortTool,
    renderGroupItem = _ref.renderGroupItem,
    disableGroupByToolbar = _ref.disableGroupByToolbar,
    rtl = _ref.rtl;
  if (!groupBy || disableGroupByToolbar) {
    return null;
  }
  return _react.default.createElement(_GroupToolbar.default, {
    ref: ref,
    rtl: rtl,
    theme: theme,
    onGroupByChange: onGroupByChange,
    onItemMouseDown: onItemMouseDown,
    renderGroupItem: renderGroupItem,
    renderSortTool: renderSortTool,
    placeholder: headerGroupPlaceholderText,
    columns: columnsMap,
    groupBy: groupBy,
    onSortClick: onSortClick
  });
};
exports.default = _default;